import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const getLastEquipmentEventsTableColumnsConfig = (): TableColumnItem[] => [
  {
    propName: 'model',
    captionTranslateKey: 'monitoring.dashboard.events.table.cols.model',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'worker',
    captionTranslateKey: 'monitoring.dashboard.events.table.cols.worker',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'ipAddress',
    captionTranslateKey: 'monitoring.dashboard.events.table.cols.ipAddress',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'description',
    captionTranslateKey: 'monitoring.dashboard.events.table.cols.description',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'date',
    captionTranslateKey: 'monitoring.dashboard.events.table.cols.date',
    type: TableColumnTypeEnum.Other,
  },
];
